import { useState } from "react";
import {
  ButtonContantUs,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSecurity,
  ContainerButton,
  ContainerLocalDataPage,
  HeaderLocalDataPage,
  Languages,
  TitlePage,
  NameUser,
  NicNameUserColor,
  DeleteDataButton,
  TitlePageMobile,
  ContainerDeleteData,
  ButtonCredits,
} from "./LocalDataStyles.styled";
import { STORAGE_KEYS } from "./localKey";
import { ButtonLogOut } from "../../../Components/ModelWindows/Logout/LogOut.styled";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { Logout } from "../../../Components/ModelWindows/Logout/Logout";
import useAuth from "../../../Redux/useAuth";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";
import { NavLink } from "react-router-dom";
import { ButtonBackPage } from "../SecurityPage/SecurityPageStyles.styled";
import { ButtonBackPageIcon } from "../../MainInfo/Icons/Icons";

export const LocalDataPage = () => {
  const { user } = useAuth();
  const { t } = useLanguageContext();

  const [openModelLogOut, setOpenModelLogOut] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };

  const deleteLocalData = () => {
    clearLocalStorageKeys([
      STORAGE_KEYS.LANG,
      STORAGE_KEYS.I18N,
      // STORAGE_KEYS.THEME,
      // STORAGE_KEYS.SwicherLG,
      // STORAGE_KEYS.SwicherIcon,
    ]);
    window.location.reload();
  };

  const clearLocalStorageKeys = (keys) => {
    keys.forEach((key) => localStorage.removeItem(key));
  };

  return (
    <>
      <HeaderLocalDataPage>
        <NavLink to={`/home-page/${user?.name?.toLowerCase()}}`}>
          <ButtonBackPage>
            <ButtonBackPageIcon />
          </ButtonBackPage>
        </NavLink>
        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>
        <TitlePage>{t("privateTraslate.LocalDataPage")}</TitlePage>
      </HeaderLocalDataPage>

      <ContainerLocalDataPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
            <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
          </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonCredits>{t("privateTraslate.ButtonCredit")}</ButtonCredits>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>
        <ContainerDeleteData>
          <TitlePageMobile>
            {t("privateTraslate.LocalDataPage")}
          </TitlePageMobile>
          <DeleteDataButton onClick={deleteLocalData} type="button">
            {t("privateTraslate.deleteLocalData")}
          </DeleteDataButton>
        </ContainerDeleteData>
      </ContainerLocalDataPage>
      {showLogOut && (
        <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
          <Logout onClose={closeLogOut} />
        </ModelWindow>
      )}
    </>
  );
};
